import { render, staticRenderFns } from "./permisInfo.vue?vue&type=template&id=58bde8df"
import script from "./permisInfo.vue?vue&type=script&lang=js"
export * from "./permisInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports